// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AfkGoldRouteImport } from './routes/afk-gold'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BinderRouteImport } from './routes/binder'
import { Route as BinderRewardsRouteImport } from './routes/binder-rewards'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as BlogAdminRouteImport } from './routes/blog-admin'
import { Route as BoosterPackRouteImport } from './routes/booster-pack'
import { Route as BossRouteRouteImport } from './routes/boss-route'
import { Route as BossesRouteImport } from './routes/bosses'
import { Route as BreedingRouteImport } from './routes/breeding'
import { Route as BuildSimRouteImport } from './routes/build-sim'
import { Route as CakeBakeRouteImport } from './routes/cake-bake'
import { Route as CaptureRatesRouteImport } from './routes/capture-rates'
import { Route as CardCheckerRouteImport } from './routes/card-checker'
import { Route as CardMarketRouteImport } from './routes/card-market'
import { Route as CardMarketplaceRouteImport } from './routes/card-marketplace'
import { Route as CardMatchRouteImport } from './routes/card-match'
import { Route as CardValueCalculatorRouteImport } from './routes/card-value-calculator'
import { Route as CardsRouteImport } from './routes/cards'
import { Route as CollectionRouteImport } from './routes/collection'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DailyPuzzleRouteImport } from './routes/daily-puzzle'
import { Route as DamageRouteImport } from './routes/damage'
import { Route as DataIntegrityRouteImport } from './routes/data-integrity'
import { Route as DeckBuilderRouteImport } from './routes/deck-builder'
import { Route as EggsRouteImport } from './routes/eggs'
import { Route as EidrolonRouteImport } from './routes/eidrolon'
import { Route as ElementsRouteImport } from './routes/elements'
import { Route as FavoritesRouteImport } from './routes/favorites'
import { Route as FusionLabRouteImport } from './routes/fusion-lab'
import { Route as GradedCardPricesRouteImport } from './routes/graded-card-prices'
import { Route as GuideAuditRouteImport } from './routes/guide-audit'
import { Route as GuidesRouteImport } from './routes/guides'
import { Route as ItemsRouteImport } from './routes/items'
import { Route as LeaderboardRouteImport } from './routes/leaderboard'
import { Route as LinkAuditRouteImport } from './routes/link-audit'
import { Route as MapRouteImport } from './routes/map'
import { Route as MarketplaceRouteImport } from './routes/marketplace'
import { Route as MerchRouteImport } from './routes/merch'
import { Route as MostExpensivePalworldCardsRouteImport } from './routes/most-expensive-palworld-cards'
import { Route as MountsRouteImport } from './routes/mounts'
import { Route as PackCalculatorRouteImport } from './routes/pack-calculator'
import { Route as PackOpeningRouteImport } from './routes/pack-opening'
import { Route as PalBracketRouteImport } from './routes/pal-bracket'
import { Route as PalCatchRouteImport } from './routes/pal-catch'
import { Route as PalDraftRouteImport } from './routes/pal-draft'
import { Route as PalsRouteImport } from './routes/pals'
import { Route as PalsinoRouteImport } from './routes/palsino'
import { Route as PalworldAlternateArtPriceGuideRouteImport } from './routes/palworld-alternate-art-price-guide'
import { Route as PalworldGamesRouteImport } from './routes/palworld-games'
import { Route as PalworldTcgRouteImport } from './routes/palworld-tcg'
import { Route as PalworldWikiRouteImport } from './routes/palworld-wiki'
import { Route as PassivesRouteImport } from './routes/passives'
import { Route as PermissionsInspectorRouteImport } from './routes/permissions-inspector'
import { Route as PlayersRouteImport } from './routes/players'
import { Route as PressRouteImport } from './routes/press'
import { Route as PriceDashboardRouteImport } from './routes/price-dashboard'
import { Route as PriceGuessRouteImport } from './routes/price-guess'
import { Route as PricesRouteImport } from './routes/prices'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RewardsRouteImport } from './routes/rewards'
import { Route as SecurityDisclaimerRouteImport } from './routes/security-disclaimer'
import { Route as SeoAuditRouteImport } from './routes/seo-audit'
import { Route as SeoMonitorRouteImport } from './routes/seo-monitor'
import { Route as TcgBulkOrderRouteImport } from './routes/tcg-bulk-order'
import { Route as TcgMarketReportRouteImport } from './routes/tcg-market-report'
import { Route as TcgPriceIndexRouteImport } from './routes/tcg-price-index'
import { Route as TcgSoldPricesRouteImport } from './routes/tcg-sold-prices'
import { Route as TcgToolsRouteImport } from './routes/tcg-tools'
import { Route as TeamBuilderRouteImport } from './routes/team-builder'
import { Route as TechnologyTreeRouteImport } from './routes/technology-tree'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TierListRouteImport } from './routes/tier-list'
import { Route as TiktokRouteImport } from './routes/tiktok'
import { Route as TradesRouteImport } from './routes/trades'
import { Route as TypeDuelRouteImport } from './routes/type-duel'
import { Route as WantListRouteImport } from './routes/want-list'
import { Route as WeeklyTournamentRouteImport } from './routes/weekly-tournament'
import { Route as WhosThatPalRouteImport } from './routes/whos-that-pal'
import { Route as BinderShareTokenRouteImport } from './routes/binder-share.$token'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as BoosterPackLegendsAwakenRouteImport } from './routes/booster-pack_.legends-awaken'
import { Route as CardsIndexRouteImport } from './routes/cards.index'
import { Route as CardsCodeRouteImport } from './routes/cards.$code'
import { Route as CardsChilletSspRawValueRouteImport } from './routes/cards.chillet-ssp-raw-value'
import { Route as CardsFrostallionSspMarketValueRouteImport } from './routes/cards.frostallion-ssp-market-value'
import { Route as CardsJetragonSspMarketValueRouteImport } from './routes/cards.jetragon-ssp-market-value'
import { Route as CollectionShareTokenRouteImport } from './routes/collection-share.$token'
import { Route as DecksGrizzboltAggroBuildRouteImport } from './routes/decks.grizzbolt-aggro-build'
import { Route as GradedCardPricesIndexRouteImport } from './routes/graded-card-prices.index'
import { Route as GradedCardPricesCodeRouteImport } from './routes/graded-card-prices.$code'
import { Route as GuidesIndexRouteImport } from './routes/guides.index'
import { Route as GuidesSlugRouteImport } from './routes/guides.$slug'
import { Route as GuidesPalworldMobileGarenaRouteImport } from './routes/guides.palworld-mobile-garena'
import { Route as GuidesPalworldMobileKraftonRouteImport } from './routes/guides.palworld-mobile-krafton'
import { Route as GuidesPalworldMobileStrategyHubRouteImport } from './routes/guides.palworld-mobile-strategy-hub'
import { Route as GuidesPalworldSleeveAndCardSetVol1CardsRouteImport } from './routes/guides.palworld-sleeve-and-card-set-vol-1-cards'
import { Route as GuidesPalworldTcgSleeveSetVol2RouteImport } from './routes/guides.palworld-tcg-sleeve-set-vol-2'
import { Route as ItemsIndexRouteImport } from './routes/items.index'
import { Route as ItemsSlugRouteImport } from './routes/items.$slug'
import { Route as MerchIndexRouteImport } from './routes/merch.index'
import { Route as MerchLineRouteImport } from './routes/merch.$line'
import { Route as PalsIndexRouteImport } from './routes/pals.index'
import { Route as PalsSlugRouteImport } from './routes/pals.$slug'
import { Route as PalworldCardValueIndexRouteImport } from './routes/palworld-card-value.index'
import { Route as PalworldCardValueCodeRouteImport } from './routes/palworld-card-value.$code'
import { Route as PalworldTcgIndexRouteImport } from './routes/palworld-tcg.index'
import { Route as PalworldTcgTopicRouteImport } from './routes/palworld-tcg.$topic'
import { Route as PalworldWikiIndexRouteImport } from './routes/palworld-wiki.index'
import { Route as PalworldWikiTopicRouteImport } from './routes/palworld-wiki.$topic'
import { Route as PassivesIndexRouteImport } from './routes/passives.index'
import { Route as PassivesSlugRouteImport } from './routes/passives.$slug'
import { Route as PlayersIndexRouteImport } from './routes/players.index'
import { Route as PlayersHandleRouteImport } from './routes/players.$handle'
import { Route as PricesLegendsAwakenRouteImport } from './routes/prices_.legends-awaken'
import { Route as PullCodeRouteImport } from './routes/pull.$code'
import { Route as SharedBinderUserIdRouteImport } from './routes/shared-binder.$userId'
import { Route as TcgIndexSnapshotWeekRouteImport } from './routes/tcg-index-snapshot.$week'
import { Route as TechnologyTreeIndexRouteImport } from './routes/technology-tree.index'
import { Route as TechnologyTreeSlugRouteImport } from './routes/technology-tree.$slug'
import { Route as GuidesSlugIndexRouteImport } from './routes/guides.$slug.index'
import { Route as GuidesSlugArticleRouteImport } from './routes/guides.$slug.$article'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/account.lazy').then((d) => d.Route))
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AfkGoldRoute = AfkGoldRouteImport.update({
            id: '/afk-gold',path: '/afk-gold',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/auth.lazy').then((d) => d.Route))
const BinderRoute = BinderRouteImport.update({
            id: '/binder',path: '/binder',getParentRoute: () => rootRouteImport
          })
const BinderRewardsRoute = BinderRewardsRouteImport.update({
            id: '/binder-rewards',path: '/binder-rewards',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const BlogAdminRoute = BlogAdminRouteImport.update({
            id: '/blog-admin',path: '/blog-admin',getParentRoute: () => rootRouteImport
          })
const BoosterPackRoute = BoosterPackRouteImport.update({
            id: '/booster-pack',path: '/booster-pack',getParentRoute: () => rootRouteImport
          })
const BossRouteRoute = BossRouteRouteImport.update({
            id: '/boss-route',path: '/boss-route',getParentRoute: () => rootRouteImport
          })
const BossesRoute = BossesRouteImport.update({
            id: '/bosses',path: '/bosses',getParentRoute: () => rootRouteImport
          })
const BreedingRoute = BreedingRouteImport.update({
            id: '/breeding',path: '/breeding',getParentRoute: () => rootRouteImport
          })
const BuildSimRoute = BuildSimRouteImport.update({
            id: '/build-sim',path: '/build-sim',getParentRoute: () => rootRouteImport
          })
const CakeBakeRoute = CakeBakeRouteImport.update({
            id: '/cake-bake',path: '/cake-bake',getParentRoute: () => rootRouteImport
          })
const CaptureRatesRoute = CaptureRatesRouteImport.update({
            id: '/capture-rates',path: '/capture-rates',getParentRoute: () => rootRouteImport
          })
const CardCheckerRoute = CardCheckerRouteImport.update({
            id: '/card-checker',path: '/card-checker',getParentRoute: () => rootRouteImport
          })
const CardMarketRoute = CardMarketRouteImport.update({
            id: '/card-market',path: '/card-market',getParentRoute: () => rootRouteImport
          })
const CardMarketplaceRoute = CardMarketplaceRouteImport.update({
            id: '/card-marketplace',path: '/card-marketplace',getParentRoute: () => rootRouteImport
          })
const CardMatchRoute = CardMatchRouteImport.update({
            id: '/card-match',path: '/card-match',getParentRoute: () => rootRouteImport
          })
const CardValueCalculatorRoute = CardValueCalculatorRouteImport.update({
            id: '/card-value-calculator',path: '/card-value-calculator',getParentRoute: () => rootRouteImport
          })
const CardsRoute = CardsRouteImport.update({
            id: '/cards',path: '/cards',getParentRoute: () => rootRouteImport
          })
const CollectionRoute = CollectionRouteImport.update({
            id: '/collection',path: '/collection',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DailyPuzzleRoute = DailyPuzzleRouteImport.update({
            id: '/daily-puzzle',path: '/daily-puzzle',getParentRoute: () => rootRouteImport
          })
const DamageRoute = DamageRouteImport.update({
            id: '/damage',path: '/damage',getParentRoute: () => rootRouteImport
          })
const DataIntegrityRoute = DataIntegrityRouteImport.update({
            id: '/data-integrity',path: '/data-integrity',getParentRoute: () => rootRouteImport
          })
const DeckBuilderRoute = DeckBuilderRouteImport.update({
            id: '/deck-builder',path: '/deck-builder',getParentRoute: () => rootRouteImport
          })
const EggsRoute = EggsRouteImport.update({
            id: '/eggs',path: '/eggs',getParentRoute: () => rootRouteImport
          })
const EidrolonRoute = EidrolonRouteImport.update({
            id: '/eidrolon',path: '/eidrolon',getParentRoute: () => rootRouteImport
          })
const ElementsRoute = ElementsRouteImport.update({
            id: '/elements',path: '/elements',getParentRoute: () => rootRouteImport
          })
const FavoritesRoute = FavoritesRouteImport.update({
            id: '/favorites',path: '/favorites',getParentRoute: () => rootRouteImport
          })
const FusionLabRoute = FusionLabRouteImport.update({
            id: '/fusion-lab',path: '/fusion-lab',getParentRoute: () => rootRouteImport
          })
const GradedCardPricesRoute = GradedCardPricesRouteImport.update({
            id: '/graded-card-prices',path: '/graded-card-prices',getParentRoute: () => rootRouteImport
          })
const GuideAuditRoute = GuideAuditRouteImport.update({
            id: '/guide-audit',path: '/guide-audit',getParentRoute: () => rootRouteImport
          })
const GuidesRoute = GuidesRouteImport.update({
            id: '/guides',path: '/guides',getParentRoute: () => rootRouteImport
          })
const ItemsRoute = ItemsRouteImport.update({
            id: '/items',path: '/items',getParentRoute: () => rootRouteImport
          })
const LeaderboardRoute = LeaderboardRouteImport.update({
            id: '/leaderboard',path: '/leaderboard',getParentRoute: () => rootRouteImport
          })
const LinkAuditRoute = LinkAuditRouteImport.update({
            id: '/link-audit',path: '/link-audit',getParentRoute: () => rootRouteImport
          })
const MapRoute = MapRouteImport.update({
            id: '/map',path: '/map',getParentRoute: () => rootRouteImport
          })
const MarketplaceRoute = MarketplaceRouteImport.update({
            id: '/marketplace',path: '/marketplace',getParentRoute: () => rootRouteImport
          })
const MerchRoute = MerchRouteImport.update({
            id: '/merch',path: '/merch',getParentRoute: () => rootRouteImport
          })
const MostExpensivePalworldCardsRoute = MostExpensivePalworldCardsRouteImport.update({
            id: '/most-expensive-palworld-cards',path: '/most-expensive-palworld-cards',getParentRoute: () => rootRouteImport
          })
const MountsRoute = MountsRouteImport.update({
            id: '/mounts',path: '/mounts',getParentRoute: () => rootRouteImport
          })
const PackCalculatorRoute = PackCalculatorRouteImport.update({
            id: '/pack-calculator',path: '/pack-calculator',getParentRoute: () => rootRouteImport
          })
const PackOpeningRoute = PackOpeningRouteImport.update({
            id: '/pack-opening',path: '/pack-opening',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/pack-opening.lazy').then((d) => d.Route))
const PalBracketRoute = PalBracketRouteImport.update({
            id: '/pal-bracket',path: '/pal-bracket',getParentRoute: () => rootRouteImport
          })
const PalCatchRoute = PalCatchRouteImport.update({
            id: '/pal-catch',path: '/pal-catch',getParentRoute: () => rootRouteImport
          })
const PalDraftRoute = PalDraftRouteImport.update({
            id: '/pal-draft',path: '/pal-draft',getParentRoute: () => rootRouteImport
          })
const PalsRoute = PalsRouteImport.update({
            id: '/pals',path: '/pals',getParentRoute: () => rootRouteImport
          })
const PalsinoRoute = PalsinoRouteImport.update({
            id: '/palsino',path: '/palsino',getParentRoute: () => rootRouteImport
          })
const PalworldAlternateArtPriceGuideRoute = PalworldAlternateArtPriceGuideRouteImport.update({
            id: '/palworld-alternate-art-price-guide',path: '/palworld-alternate-art-price-guide',getParentRoute: () => rootRouteImport
          })
const PalworldGamesRoute = PalworldGamesRouteImport.update({
            id: '/palworld-games',path: '/palworld-games',getParentRoute: () => rootRouteImport
          })
const PalworldTcgRoute = PalworldTcgRouteImport.update({
            id: '/palworld-tcg',path: '/palworld-tcg',getParentRoute: () => rootRouteImport
          })
const PalworldWikiRoute = PalworldWikiRouteImport.update({
            id: '/palworld-wiki',path: '/palworld-wiki',getParentRoute: () => rootRouteImport
          })
const PassivesRoute = PassivesRouteImport.update({
            id: '/passives',path: '/passives',getParentRoute: () => rootRouteImport
          })
const PermissionsInspectorRoute = PermissionsInspectorRouteImport.update({
            id: '/permissions-inspector',path: '/permissions-inspector',getParentRoute: () => rootRouteImport
          })
const PlayersRoute = PlayersRouteImport.update({
            id: '/players',path: '/players',getParentRoute: () => rootRouteImport
          })
const PressRoute = PressRouteImport.update({
            id: '/press',path: '/press',getParentRoute: () => rootRouteImport
          })
const PriceDashboardRoute = PriceDashboardRouteImport.update({
            id: '/price-dashboard',path: '/price-dashboard',getParentRoute: () => rootRouteImport
          })
const PriceGuessRoute = PriceGuessRouteImport.update({
            id: '/price-guess',path: '/price-guess',getParentRoute: () => rootRouteImport
          })
const PricesRoute = PricesRouteImport.update({
            id: '/prices',path: '/prices',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const RewardsRoute = RewardsRouteImport.update({
            id: '/rewards',path: '/rewards',getParentRoute: () => rootRouteImport
          })
const SecurityDisclaimerRoute = SecurityDisclaimerRouteImport.update({
            id: '/security-disclaimer',path: '/security-disclaimer',getParentRoute: () => rootRouteImport
          })
const SeoAuditRoute = SeoAuditRouteImport.update({
            id: '/seo-audit',path: '/seo-audit',getParentRoute: () => rootRouteImport
          })
const SeoMonitorRoute = SeoMonitorRouteImport.update({
            id: '/seo-monitor',path: '/seo-monitor',getParentRoute: () => rootRouteImport
          })
const TcgBulkOrderRoute = TcgBulkOrderRouteImport.update({
            id: '/tcg-bulk-order',path: '/tcg-bulk-order',getParentRoute: () => rootRouteImport
          })
const TcgMarketReportRoute = TcgMarketReportRouteImport.update({
            id: '/tcg-market-report',path: '/tcg-market-report',getParentRoute: () => rootRouteImport
          })
const TcgPriceIndexRoute = TcgPriceIndexRouteImport.update({
            id: '/tcg-price-index',path: '/tcg-price-index',getParentRoute: () => rootRouteImport
          })
const TcgSoldPricesRoute = TcgSoldPricesRouteImport.update({
            id: '/tcg-sold-prices',path: '/tcg-sold-prices',getParentRoute: () => rootRouteImport
          })
const TcgToolsRoute = TcgToolsRouteImport.update({
            id: '/tcg-tools',path: '/tcg-tools',getParentRoute: () => rootRouteImport
          })
const TeamBuilderRoute = TeamBuilderRouteImport.update({
            id: '/team-builder',path: '/team-builder',getParentRoute: () => rootRouteImport
          })
const TechnologyTreeRoute = TechnologyTreeRouteImport.update({
            id: '/technology-tree',path: '/technology-tree',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TierListRoute = TierListRouteImport.update({
            id: '/tier-list',path: '/tier-list',getParentRoute: () => rootRouteImport
          })
const TiktokRoute = TiktokRouteImport.update({
            id: '/tiktok',path: '/tiktok',getParentRoute: () => rootRouteImport
          })
const TradesRoute = TradesRouteImport.update({
            id: '/trades',path: '/trades',getParentRoute: () => rootRouteImport
          })
const TypeDuelRoute = TypeDuelRouteImport.update({
            id: '/type-duel',path: '/type-duel',getParentRoute: () => rootRouteImport
          })
const WantListRoute = WantListRouteImport.update({
            id: '/want-list',path: '/want-list',getParentRoute: () => rootRouteImport
          })
const WeeklyTournamentRoute = WeeklyTournamentRouteImport.update({
            id: '/weekly-tournament',path: '/weekly-tournament',getParentRoute: () => rootRouteImport
          })
const WhosThatPalRoute = WhosThatPalRouteImport.update({
            id: '/whos-that-pal',path: '/whos-that-pal',getParentRoute: () => rootRouteImport
          })
const BinderShareTokenRoute = BinderShareTokenRouteImport.update({
            id: '/binder-share/$token',path: '/binder-share/$token',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const BoosterPackLegendsAwakenRoute = BoosterPackLegendsAwakenRouteImport.update({
            id: '/booster-pack_/legends-awaken',path: '/booster-pack/legends-awaken',getParentRoute: () => rootRouteImport
          })
const CardsIndexRoute = CardsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CardsRoute
          })
const CardsCodeRoute = CardsCodeRouteImport.update({
            id: '/$code',path: '/$code',getParentRoute: () => CardsRoute
          })
const CardsChilletSspRawValueRoute = CardsChilletSspRawValueRouteImport.update({
            id: '/chillet-ssp-raw-value',path: '/chillet-ssp-raw-value',getParentRoute: () => CardsRoute
          })
const CardsFrostallionSspMarketValueRoute = CardsFrostallionSspMarketValueRouteImport.update({
            id: '/frostallion-ssp-market-value',path: '/frostallion-ssp-market-value',getParentRoute: () => CardsRoute
          })
const CardsJetragonSspMarketValueRoute = CardsJetragonSspMarketValueRouteImport.update({
            id: '/jetragon-ssp-market-value',path: '/jetragon-ssp-market-value',getParentRoute: () => CardsRoute
          })
const CollectionShareTokenRoute = CollectionShareTokenRouteImport.update({
            id: '/collection-share/$token',path: '/collection-share/$token',getParentRoute: () => rootRouteImport
          })
const DecksGrizzboltAggroBuildRoute = DecksGrizzboltAggroBuildRouteImport.update({
            id: '/decks/grizzbolt-aggro-build',path: '/decks/grizzbolt-aggro-build',getParentRoute: () => rootRouteImport
          })
const GradedCardPricesIndexRoute = GradedCardPricesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => GradedCardPricesRoute
          })
const GradedCardPricesCodeRoute = GradedCardPricesCodeRouteImport.update({
            id: '/$code',path: '/$code',getParentRoute: () => GradedCardPricesRoute
          })
const GuidesIndexRoute = GuidesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => GuidesRoute
          })
const GuidesSlugRoute = GuidesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => GuidesRoute
          })
const GuidesPalworldMobileGarenaRoute = GuidesPalworldMobileGarenaRouteImport.update({
            id: '/palworld-mobile-garena',path: '/palworld-mobile-garena',getParentRoute: () => GuidesRoute
          })
const GuidesPalworldMobileKraftonRoute = GuidesPalworldMobileKraftonRouteImport.update({
            id: '/palworld-mobile-krafton',path: '/palworld-mobile-krafton',getParentRoute: () => GuidesRoute
          })
const GuidesPalworldMobileStrategyHubRoute = GuidesPalworldMobileStrategyHubRouteImport.update({
            id: '/palworld-mobile-strategy-hub',path: '/palworld-mobile-strategy-hub',getParentRoute: () => GuidesRoute
          })
const GuidesPalworldSleeveAndCardSetVol1CardsRoute = GuidesPalworldSleeveAndCardSetVol1CardsRouteImport.update({
            id: '/palworld-sleeve-and-card-set-vol-1-cards',path: '/palworld-sleeve-and-card-set-vol-1-cards',getParentRoute: () => GuidesRoute
          })
const GuidesPalworldTcgSleeveSetVol2Route = GuidesPalworldTcgSleeveSetVol2RouteImport.update({
            id: '/palworld-tcg-sleeve-set-vol-2',path: '/palworld-tcg-sleeve-set-vol-2',getParentRoute: () => GuidesRoute
          })
const ItemsIndexRoute = ItemsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ItemsRoute
          })
const ItemsSlugRoute = ItemsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ItemsRoute
          })
const MerchIndexRoute = MerchIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MerchRoute
          })
const MerchLineRoute = MerchLineRouteImport.update({
            id: '/$line',path: '/$line',getParentRoute: () => MerchRoute
          })
const PalsIndexRoute = PalsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PalsRoute
          })
const PalsSlugRoute = PalsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => PalsRoute
          })
const PalworldCardValueIndexRoute = PalworldCardValueIndexRouteImport.update({
            id: '/palworld-card-value/',path: '/palworld-card-value/',getParentRoute: () => rootRouteImport
          })
const PalworldCardValueCodeRoute = PalworldCardValueCodeRouteImport.update({
            id: '/palworld-card-value/$code',path: '/palworld-card-value/$code',getParentRoute: () => rootRouteImport
          })
const PalworldTcgIndexRoute = PalworldTcgIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PalworldTcgRoute
          })
const PalworldTcgTopicRoute = PalworldTcgTopicRouteImport.update({
            id: '/$topic',path: '/$topic',getParentRoute: () => PalworldTcgRoute
          })
const PalworldWikiIndexRoute = PalworldWikiIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PalworldWikiRoute
          })
const PalworldWikiTopicRoute = PalworldWikiTopicRouteImport.update({
            id: '/$topic',path: '/$topic',getParentRoute: () => PalworldWikiRoute
          })
const PassivesIndexRoute = PassivesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PassivesRoute
          })
const PassivesSlugRoute = PassivesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => PassivesRoute
          })
const PlayersIndexRoute = PlayersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PlayersRoute
          })
const PlayersHandleRoute = PlayersHandleRouteImport.update({
            id: '/$handle',path: '/$handle',getParentRoute: () => PlayersRoute
          })
const PricesLegendsAwakenRoute = PricesLegendsAwakenRouteImport.update({
            id: '/prices_/legends-awaken',path: '/prices/legends-awaken',getParentRoute: () => rootRouteImport
          })
const PullCodeRoute = PullCodeRouteImport.update({
            id: '/pull/$code',path: '/pull/$code',getParentRoute: () => rootRouteImport
          })
const SharedBinderUserIdRoute = SharedBinderUserIdRouteImport.update({
            id: '/shared-binder/$userId',path: '/shared-binder/$userId',getParentRoute: () => rootRouteImport
          })
const TcgIndexSnapshotWeekRoute = TcgIndexSnapshotWeekRouteImport.update({
            id: '/tcg-index-snapshot/$week',path: '/tcg-index-snapshot/$week',getParentRoute: () => rootRouteImport
          })
const TechnologyTreeIndexRoute = TechnologyTreeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => TechnologyTreeRoute
          })
const TechnologyTreeSlugRoute = TechnologyTreeSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => TechnologyTreeRoute
          })
const GuidesSlugIndexRoute = GuidesSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => GuidesSlugRoute
          })
const GuidesSlugArticleRoute = GuidesSlugArticleRouteImport.update({
            id: '/$article',path: '/$article',getParentRoute: () => GuidesSlugRoute
          })





const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const CardsRouteChildren = {
  CardsCodeRoute: CardsCodeRoute,CardsChilletSspRawValueRoute: CardsChilletSspRawValueRoute,CardsFrostallionSspMarketValueRoute: CardsFrostallionSspMarketValueRoute,CardsJetragonSspMarketValueRoute: CardsJetragonSspMarketValueRoute,CardsIndexRoute: CardsIndexRoute
}

const CardsRouteWithChildren = CardsRoute._addFileChildren(CardsRouteChildren)




const GradedCardPricesRouteChildren = {
  GradedCardPricesCodeRoute: GradedCardPricesCodeRoute,GradedCardPricesIndexRoute: GradedCardPricesIndexRoute
}

const GradedCardPricesRouteWithChildren = GradedCardPricesRoute._addFileChildren(GradedCardPricesRouteChildren)




const GuidesSlugRouteChildren = {
  GuidesSlugArticleRoute: GuidesSlugArticleRoute,GuidesSlugIndexRoute: GuidesSlugIndexRoute
}

const GuidesSlugRouteWithChildren = GuidesSlugRoute._addFileChildren(GuidesSlugRouteChildren)



const GuidesRouteChildren = {
  GuidesSlugRoute: GuidesSlugRouteWithChildren,GuidesPalworldMobileGarenaRoute: GuidesPalworldMobileGarenaRoute,GuidesPalworldMobileKraftonRoute: GuidesPalworldMobileKraftonRoute,GuidesPalworldMobileStrategyHubRoute: GuidesPalworldMobileStrategyHubRoute,GuidesPalworldSleeveAndCardSetVol1CardsRoute: GuidesPalworldSleeveAndCardSetVol1CardsRoute,GuidesPalworldTcgSleeveSetVol2Route: GuidesPalworldTcgSleeveSetVol2Route,GuidesIndexRoute: GuidesIndexRoute
}

const GuidesRouteWithChildren = GuidesRoute._addFileChildren(GuidesRouteChildren)




const ItemsRouteChildren = {
  ItemsSlugRoute: ItemsSlugRoute,ItemsIndexRoute: ItemsIndexRoute
}

const ItemsRouteWithChildren = ItemsRoute._addFileChildren(ItemsRouteChildren)




const MerchRouteChildren = {
  MerchLineRoute: MerchLineRoute,MerchIndexRoute: MerchIndexRoute
}

const MerchRouteWithChildren = MerchRoute._addFileChildren(MerchRouteChildren)




const PalsRouteChildren = {
  PalsSlugRoute: PalsSlugRoute,PalsIndexRoute: PalsIndexRoute
}

const PalsRouteWithChildren = PalsRoute._addFileChildren(PalsRouteChildren)




const PalworldTcgRouteChildren = {
  PalworldTcgTopicRoute: PalworldTcgTopicRoute,PalworldTcgIndexRoute: PalworldTcgIndexRoute
}

const PalworldTcgRouteWithChildren = PalworldTcgRoute._addFileChildren(PalworldTcgRouteChildren)




const PalworldWikiRouteChildren = {
  PalworldWikiTopicRoute: PalworldWikiTopicRoute,PalworldWikiIndexRoute: PalworldWikiIndexRoute
}

const PalworldWikiRouteWithChildren = PalworldWikiRoute._addFileChildren(PalworldWikiRouteChildren)




const PassivesRouteChildren = {
  PassivesSlugRoute: PassivesSlugRoute,PassivesIndexRoute: PassivesIndexRoute
}

const PassivesRouteWithChildren = PassivesRoute._addFileChildren(PassivesRouteChildren)




const PlayersRouteChildren = {
  PlayersHandleRoute: PlayersHandleRoute,PlayersIndexRoute: PlayersIndexRoute
}

const PlayersRouteWithChildren = PlayersRoute._addFileChildren(PlayersRouteChildren)




const TechnologyTreeRouteChildren = {
  TechnologyTreeSlugRoute: TechnologyTreeSlugRoute,TechnologyTreeIndexRoute: TechnologyTreeIndexRoute
}

const TechnologyTreeRouteWithChildren = TechnologyTreeRoute._addFileChildren(TechnologyTreeRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AboutRoute: AboutRoute,AccountRoute: AccountRoute,AdminRoute: AdminRoute,AfkGoldRoute: AfkGoldRoute,AuthRoute: AuthRoute,BinderRoute: BinderRoute,BinderRewardsRoute: BinderRewardsRoute,BlogRoute: BlogRouteWithChildren,BlogAdminRoute: BlogAdminRoute,BoosterPackRoute: BoosterPackRoute,BossRouteRoute: BossRouteRoute,BossesRoute: BossesRoute,BreedingRoute: BreedingRoute,BuildSimRoute: BuildSimRoute,CakeBakeRoute: CakeBakeRoute,CaptureRatesRoute: CaptureRatesRoute,CardCheckerRoute: CardCheckerRoute,CardMarketRoute: CardMarketRoute,CardMarketplaceRoute: CardMarketplaceRoute,CardMatchRoute: CardMatchRoute,CardValueCalculatorRoute: CardValueCalculatorRoute,CardsRoute: CardsRouteWithChildren,CollectionRoute: CollectionRoute,ContactRoute: ContactRoute,DailyPuzzleRoute: DailyPuzzleRoute,DamageRoute: DamageRoute,DataIntegrityRoute: DataIntegrityRoute,DeckBuilderRoute: DeckBuilderRoute,EggsRoute: EggsRoute,EidrolonRoute: EidrolonRoute,ElementsRoute: ElementsRoute,FavoritesRoute: FavoritesRoute,FusionLabRoute: FusionLabRoute,GradedCardPricesRoute: GradedCardPricesRouteWithChildren,GuideAuditRoute: GuideAuditRoute,GuidesRoute: GuidesRouteWithChildren,ItemsRoute: ItemsRouteWithChildren,LeaderboardRoute: LeaderboardRoute,LinkAuditRoute: LinkAuditRoute,MapRoute: MapRoute,MarketplaceRoute: MarketplaceRoute,MerchRoute: MerchRouteWithChildren,MostExpensivePalworldCardsRoute: MostExpensivePalworldCardsRoute,MountsRoute: MountsRoute,PackCalculatorRoute: PackCalculatorRoute,PackOpeningRoute: PackOpeningRoute,PalBracketRoute: PalBracketRoute,PalCatchRoute: PalCatchRoute,PalDraftRoute: PalDraftRoute,PalsRoute: PalsRouteWithChildren,PalsinoRoute: PalsinoRoute,PalworldAlternateArtPriceGuideRoute: PalworldAlternateArtPriceGuideRoute,PalworldGamesRoute: PalworldGamesRoute,PalworldTcgRoute: PalworldTcgRouteWithChildren,PalworldWikiRoute: PalworldWikiRouteWithChildren,PassivesRoute: PassivesRouteWithChildren,PermissionsInspectorRoute: PermissionsInspectorRoute,PlayersRoute: PlayersRouteWithChildren,PressRoute: PressRoute,PriceDashboardRoute: PriceDashboardRoute,PriceGuessRoute: PriceGuessRoute,PricesRoute: PricesRoute,PrivacyRoute: PrivacyRoute,RewardsRoute: RewardsRoute,SecurityDisclaimerRoute: SecurityDisclaimerRoute,SeoAuditRoute: SeoAuditRoute,SeoMonitorRoute: SeoMonitorRoute,TcgBulkOrderRoute: TcgBulkOrderRoute,TcgMarketReportRoute: TcgMarketReportRoute,TcgPriceIndexRoute: TcgPriceIndexRoute,TcgSoldPricesRoute: TcgSoldPricesRoute,TcgToolsRoute: TcgToolsRoute,TeamBuilderRoute: TeamBuilderRoute,TechnologyTreeRoute: TechnologyTreeRouteWithChildren,TermsRoute: TermsRoute,TierListRoute: TierListRoute,TiktokRoute: TiktokRoute,TradesRoute: TradesRoute,TypeDuelRoute: TypeDuelRoute,WantListRoute: WantListRoute,WeeklyTournamentRoute: WeeklyTournamentRoute,WhosThatPalRoute: WhosThatPalRoute,BinderShareTokenRoute: BinderShareTokenRoute,BoosterPackLegendsAwakenRoute: BoosterPackLegendsAwakenRoute,CollectionShareTokenRoute: CollectionShareTokenRoute,DecksGrizzboltAggroBuildRoute: DecksGrizzboltAggroBuildRoute,PalworldCardValueCodeRoute: PalworldCardValueCodeRoute,PricesLegendsAwakenRoute: PricesLegendsAwakenRoute,PullCodeRoute: PullCodeRoute,SharedBinderUserIdRoute: SharedBinderUserIdRoute,TcgIndexSnapshotWeekRoute: TcgIndexSnapshotWeekRoute,PalworldCardValueIndexRoute: PalworldCardValueIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)